import type { TechnicalProduct } from './technical-catalog'

const checkedAt = '2026-10-11'

// Manufacturer reference facts only: these cards are not listings, offers or reviews.
// Zoom ranges are kept as text. A variable aperture never becomes a single-number ranking.
export const cameraLensCatalog: TechnicalProduct[] = [
  {
    id: 'sony-a7r-iv', name: 'Sony α7R IV (ILCE-7RM4)', kind: 'cameras', checkedAt, mount: 'sony_e',
    sourceUrl: 'https://www.sony.com/electronics/support/e-mount-body-ilce-7-series/ilce-7rm4/specifications',
    facts: { 'Sensore': 'Full frame CMOS', 'Pixel effettivi': '61 MP', 'Attacco': 'Sony E', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '665 g circa' },
    numeric: { megapixels: 61, weightGrams: 665 },
    note: 'Scheda del modello ILCE-7RM4, non della revisione ILCE-7RM4A. La stabilizzazione dipende anche dall’obiettivo.'
  },
  {
    id: 'sony-a6400', name: 'Sony α6400 (ILCE-6400)', kind: 'cameras', checkedAt, mount: 'sony_e',
    sourceUrl: 'https://www.sony.com/electronics/support/e-mount-body-ilce-6000-series/ilce-6400/specifications',
    facts: { 'Sensore': 'APS-C CMOS', 'Pixel effettivi': '24,2 MP', 'Attacco': 'Sony E', 'Stabilizzazione': 'Nessuna sul sensore; dipende dall’obiettivo', 'Peso con batteria e scheda': '403 g circa' },
    numeric: { megapixels: 24.2, weightGrams: 403 },
    note: 'Scheda del modello ILCE-6400, non della revisione ILCE-6400A.'
  },
  {
    id: 'sony-a6600', name: 'Sony α6600', kind: 'cameras', checkedAt, mount: 'sony_e',
    sourceUrl: 'https://www.sony.com/electronics/support/e-mount-body-ilce-6000-series/ilce-6600/specifications',
    facts: { 'Sensore': 'APS-C CMOS', 'Pixel effettivi': '24,2 MP', 'Attacco': 'Sony E', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '503 g circa' },
    numeric: { megapixels: 24.2, weightGrams: 503 },
    note: 'La stabilizzazione dipende anche dalle specifiche dell’obiettivo.'
  },
  {
    id: 'canon-r5', name: 'Canon EOS R5', kind: 'cameras', checkedAt, mount: 'canon_rf',
    sourceUrl: 'https://cam.start.canon/en/C003/manual/html/UG-09_Reference_0100.html',
    facts: { 'Sensore': 'Full frame CMOS', 'Pixel effettivi': '45 MP circa', 'Attacco': 'Canon RF', 'Peso con batteria e scheda': '738 g circa' },
    numeric: { megapixels: 45, weightGrams: 738 },
    note: 'EOS R5 originale, non R5 Mark II. Peso con scheda CFexpress, senza tappo del corpo. Il numero effettivo di pixel può variare con ottica e ritaglio.'
  },
  {
    id: 'canon-r7', name: 'Canon EOS R7', kind: 'cameras', checkedAt, mount: 'canon_rf',
    sourceUrl: 'https://cam.start.canon/en/C005/manual/html/UG-10_Reference_0100.html',
    facts: { 'Sensore': 'APS-C CMOS', 'Pixel effettivi': '32,5 MP circa', 'Attacco': 'Canon RF', 'Obiettivi nativi': 'RF e RF-S', 'Peso con batteria e scheda': '612 g circa' },
    numeric: { megapixels: 32.5, weightGrams: 612 },
    note: 'Il peso comprende una scheda; esclude tappo del corpo e copertura della slitta. EF/EF-S richiedono adattatore; EF-M non compatibili.'
  },
  {
    id: 'canon-r10', name: 'Canon EOS R10', kind: 'cameras', checkedAt, mount: 'canon_rf',
    sourceUrl: 'https://cam.start.canon/en/C006/manual/html/UG-11_Reference_0090.html',
    facts: { 'Sensore': 'APS-C CMOS', 'Pixel effettivi': '24,2 MP circa', 'Attacco': 'Canon RF', 'Obiettivi nativi': 'RF e RF-S', 'Peso con batteria e scheda': '429 g circa' },
    numeric: { megapixels: 24.2, weightGrams: 429 },
    note: 'Peso con batteria e scheda SD, senza tappo del corpo e copertura della slitta. EF/EF-S richiedono adattatore; EF-M non compatibili.'
  },
  {
    id: 'nikon-z6-ii', name: 'Nikon Z 6II', kind: 'cameras', checkedAt, mount: 'nikon_z',
    sourceUrl: 'https://onlinemanual.nikonimglib.com/z7II_z6II/en/15_technical_notes_08.html',
    facts: { 'Sensore': 'Full frame CMOS (FX)', 'Pixel effettivi': '24,5 MP', 'Attacco': 'Nikon Z', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '705 g circa' },
    numeric: { megapixels: 24.5, weightGrams: 705 },
    note: 'Peso senza tappo del corpo. Gli obiettivi Nikon F richiedono adattatore; possono esserci limitazioni.'
  },
  {
    id: 'nikon-z7-ii', name: 'Nikon Z 7II', kind: 'cameras', checkedAt, mount: 'nikon_z',
    sourceUrl: 'https://onlinemanual.nikonimglib.com/z7II_z6II/en/15_technical_notes_08.html',
    facts: { 'Sensore': 'Full frame CMOS (FX)', 'Pixel effettivi': '45,7 MP', 'Attacco': 'Nikon Z', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '705 g circa' },
    numeric: { megapixels: 45.7, weightGrams: 705 },
    note: 'Peso senza tappo del corpo. Gli obiettivi Nikon F richiedono adattatore; possono esserci limitazioni.'
  },
  {
    id: 'nikon-z50', name: 'Nikon Z 50', kind: 'cameras', checkedAt, mount: 'nikon_z',
    sourceUrl: 'https://imaging.nikon.com/imaging/lineup/mirrorless/z_50/',
    facts: { 'Sensore': 'APS-C CMOS (DX)', 'Pixel effettivi': '20,9 MP', 'Attacco': 'Nikon Z', 'Peso con batteria e scheda': '450 g circa' },
    numeric: { megapixels: 20.9, weightGrams: 450 },
    note: 'Z 50 originale, non Z50II. Peso senza tappo del corpo; gli obiettivi Nikon F richiedono adattatore e possono avere limitazioni.'
  },
  {
    id: 'fujifilm-x-t4', name: 'Fujifilm X-T4', kind: 'cameras', checkedAt, mount: 'fujifilm_x',
    sourceUrl: 'https://www.fujifilm-x.com/en-us/products/cameras/x-t4/',
    facts: { 'Sensore': 'APS-C X-Trans CMOS 4', 'Pixel effettivi': '26,1 MP', 'Attacco': 'Fujifilm X', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '607 g circa' },
    numeric: { megapixels: 26.1, weightGrams: 607 }
  },
  {
    id: 'fujifilm-x-t5', name: 'Fujifilm X-T5', kind: 'cameras', checkedAt, mount: 'fujifilm_x',
    sourceUrl: 'https://www.fujifilm-x.com/en-us/products/cameras/x-t5/specifications/',
    facts: { 'Sensore': 'APS-C X-Trans CMOS 5 HR', 'Pixel effettivi': '40,2 MP', 'Attacco': 'Fujifilm X', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '557 g circa' },
    numeric: { megapixels: 40.2, weightGrams: 557 }
  },
  {
    id: 'fujifilm-x-s20', name: 'Fujifilm X-S20', kind: 'cameras', checkedAt, mount: 'fujifilm_x',
    sourceUrl: 'https://www.fujifilm-x.com/en-us/products/cameras/x-s20/specifications/',
    facts: { 'Sensore': 'APS-C X-Trans CMOS 4', 'Pixel effettivi': '26,1 MP', 'Attacco': 'Fujifilm X', 'Stabilizzazione': 'Sul sensore, 5 assi', 'Peso con batteria e scheda': '491 g circa' },
    numeric: { megapixels: 26.1, weightGrams: 491 }
  },
  {
    id: 'sony-fe-35-18', name: 'Sony FE 35mm F1.8', kind: 'lenses', checkedAt, mount: 'sony_e',
    sourceUrl: 'https://www.sony.com/electronics/support/lenses-e-mount-lenses/sel35f18f/specifications',
    facts: { 'Attacco': 'Sony E', 'Copertura del sensore': 'Full frame', 'Focale': '35 mm', 'Apertura massima': 'f/1,8', 'Stabilizzazione ottica': 'No', 'Peso dichiarato': '280 g' },
    numeric: { focalMm: 35, fNumber: 1.8, weightGrams: 280 },
    note: 'Modello SEL35F18F per full frame, non Sony E 35mm F1.8 OSS per APS-C. La stabilizzazione può essere disponibile sul corpo macchina.'
  },
  {
    id: 'sony-fe-85-18', name: 'Sony FE 85mm F1.8', kind: 'lenses', checkedAt, mount: 'sony_e',
    sourceUrl: 'https://www.sony.com/electronics/support/lenses-e-mount-lenses/sel85f18/specifications',
    facts: { 'Attacco': 'Sony E', 'Copertura del sensore': 'Full frame', 'Focale': '85 mm', 'Apertura massima': 'f/1,8', 'Stabilizzazione ottica': 'No', 'Peso dichiarato': '371 g' },
    numeric: { focalMm: 85, fNumber: 1.8, weightGrams: 371 },
    note: 'Modello SEL85F18. La stabilizzazione può essere disponibile sul corpo macchina.'
  },
  {
    id: 'sony-fe-24-70-28-gm-ii', name: 'Sony FE 24-70mm F2.8 GM II', kind: 'lenses', checkedAt, mount: 'sony_e',
    sourceUrl: 'https://www.sony.com/electronics/support/lenses-e-mount-lenses/sel2470gm2/specifications',
    facts: { 'Attacco': 'Sony E', 'Copertura del sensore': 'Full frame', 'Focale': '24–70 mm', 'Apertura massima': 'f/2,8 costante', 'Stabilizzazione ottica': 'No', 'Peso dichiarato': '695 g' },
    numeric: { fNumber: 2.8, weightGrams: 695 },
    note: 'Seconda generazione SEL2470GM2, non il precedente SEL2470GM. Lo zoom non ha una sola focale.'
  },
  {
    id: 'canon-rf-35-18-macro', name: 'Canon RF 35mm F1.8 MACRO IS STM', kind: 'lenses', checkedAt, mount: 'canon_rf',
    sourceUrl: 'https://global.canon/en/c-museum/product/rf473.html',
    facts: { 'Attacco': 'Canon RF', 'Focale': '35 mm', 'Apertura massima': 'f/1,8', 'Stabilizzazione ottica': 'Sì', 'Rapporto di riproduzione massimo': '0,5×', 'Peso dichiarato': '305 g circa' },
    numeric: { focalMm: 35, fNumber: 1.8, weightGrams: 305 },
    note: 'Macro con rapporto massimo 0,5×: non riproduzione 1:1. La prestazione della stabilizzazione dipende dal corpo e dalle condizioni di ripresa.'
  },
  {
    id: 'canon-rf-24-105-4-l', name: 'Canon RF 24-105mm F4 L IS USM', kind: 'lenses', checkedAt, mount: 'canon_rf',
    sourceUrl: 'https://www.usa.canon.com/support/p/rf24-105mm-f4-l-is-usm',
    facts: { 'Attacco': 'Canon RF', 'Focale': '24–105 mm', 'Apertura massima': 'f/4 costante', 'Messa a fuoco': 'Autofocus con intervento manuale continuo', 'Peso dichiarato': '700 g circa' },
    numeric: { fNumber: 4, weightGrams: 700 },
    note: 'Modello RF della serie L a f/4 costante; non RF 24-105mm F4-7.1 IS STM, EF o RF F2.8 Z.'
  },
  {
    id: 'canon-rf-100-500-45-71-l', name: 'Canon RF 100-500mm F4.5-7.1 L IS USM', kind: 'lenses', checkedAt, mount: 'canon_rf',
    sourceUrl: 'https://asia.canon/en/consumer/rf100-500mm-f-4-5-7-1l-is-usm/main/specification',
    facts: { 'Attacco': 'Canon RF', 'Focale': '100–500 mm', 'Apertura massima': 'f/4,5–7,1 variabile', 'Stabilizzazione ottica': 'Sì', 'Messa a fuoco': 'Doppio Nano USM', 'Rapporto di riproduzione massimo': '0,33× a 500 mm' },
    numeric: {},
    note: 'L’apertura massima cambia con la focale: non viene usato un singolo valore per classificarne la luminosità. Con moltiplicatori RF lo zoom ha limitazioni: verifica il manuale.'
  },
  {
    id: 'nikon-z-50-18-s', name: 'Nikon NIKKOR Z 50mm f/1.8 S', kind: 'lenses', checkedAt, mount: 'nikon_z',
    sourceUrl: 'https://imaging.nikon.com/imaging/lineup/lens/z-mount/z_50mmf18s/',
    facts: { 'Attacco': 'Nikon Z', 'Copertura del sensore': 'Full frame (FX)', 'Focale': '50 mm', 'Apertura massima': 'f/1,8', 'Peso dichiarato': '415 g circa' },
    numeric: { focalMm: 50, fNumber: 1.8, weightGrams: 415 }
  },
  {
    id: 'nikon-z-24-70-4-s', name: 'Nikon NIKKOR Z 24-70mm f/4 S', kind: 'lenses', checkedAt, mount: 'nikon_z',
    sourceUrl: 'https://imaging.nikon.com/imaging/lineup/lens/z-mount/z_24-70mmf4s/index.html',
    facts: { 'Attacco': 'Nikon Z', 'Copertura del sensore': 'Full frame (FX)', 'Focale': '24–70 mm', 'Apertura massima': 'f/4 costante', 'Peso dichiarato': '500 g circa' },
    numeric: { fNumber: 4, weightGrams: 500 },
    note: 'Non il NIKKOR Z 24-70mm f/2.8 S. Lo zoom non ha una sola focale.'
  },
  {
    id: 'nikon-z-mc-105-28-vr-s', name: 'Nikon NIKKOR Z MC 105mm f/2.8 VR S', kind: 'lenses', checkedAt, mount: 'nikon_z',
    sourceUrl: 'https://imaging.nikon.com/imaging/lineup/lens/z-mount/z_mc105mmf28_vr_s/',
    facts: { 'Attacco': 'Nikon Z', 'Copertura del sensore': 'Full frame (FX)', 'Focale': '105 mm', 'Apertura massima': 'f/2,8 all’infinito; f/4,5 alla distanza minima', 'Stabilizzazione ottica': 'Sì, VR', 'Rapporto di riproduzione massimo': '1× (1:1)', 'Peso dichiarato': '630 g circa' },
    numeric: { focalMm: 105, fNumber: 2.8, weightGrams: 630 },
    note: 'Il valore f/2,8 del confronto vale all’infinito. Alla minima distanza di messa a fuoco, 0,29 m, l’apertura massima effettiva è f/4,5.'
  },
  {
    id: 'fujifilm-xf-35-14-r', name: 'Fujifilm FUJINON XF35mmF1.4 R', kind: 'lenses', checkedAt, mount: 'fujifilm_x',
    sourceUrl: 'https://www.fujifilm-x.com/en-nz/products/lenses/xf35mmf14-r/specifications/',
    facts: { 'Attacco': 'Fujifilm X', 'Focale': '35 mm', 'Apertura massima': 'f/1,4', 'Focale equivalente dichiarata (35 mm)': '53 mm', 'Peso dichiarato': '187 g circa, senza tappi e paraluce' },
    numeric: { focalMm: 35, fNumber: 1.4, weightGrams: 187 },
    note: 'Obiettivo per il sistema X APS-C, non per Fujifilm GFX. La focale fisica di 35 mm non è la focale equivalente di 53 mm.'
  },
  {
    id: 'fujifilm-xf-18-55-28-4', name: 'Fujifilm FUJINON XF18-55mmF2.8-4 R LM OIS', kind: 'lenses', checkedAt, mount: 'fujifilm_x',
    sourceUrl: 'https://www.fujifilm-x.com/global/products/lenses/xf18-55mmf28-4-r-lm-ois/specifications/',
    facts: { 'Attacco': 'Fujifilm X', 'Focale': '18–55 mm', 'Apertura massima': 'f/2,8–4 variabile', 'Focale equivalente dichiarata (35 mm)': '27–84 mm', 'Peso dichiarato': '310 g circa, senza tappi e paraluce' },
    numeric: { weightGrams: 310 },
    note: 'Obiettivo per il sistema X APS-C, non GFX. L’apertura massima cambia con la focale: non viene usato un singolo valore per classificarne la luminosità.'
  },
  {
    id: 'fujifilm-xf-70-300-4-56', name: 'Fujifilm FUJINON XF70-300mmF4-5.6 R LM OIS WR', kind: 'lenses', checkedAt, mount: 'fujifilm_x',
    sourceUrl: 'https://www.fujifilm-x.com/en-gb/products/lenses/xf70-300mmf4-56-r-lm-ois-wr/specifications/',
    facts: { 'Attacco': 'Fujifilm X', 'Focale': '70–300 mm', 'Apertura massima': 'f/4–5,6 variabile', 'Focale equivalente dichiarata (35 mm)': '107–457 mm', 'Peso dichiarato': '580 g circa, senza tappi e paraluce' },
    numeric: { weightGrams: 580 },
    note: 'Obiettivo per il sistema X APS-C, non GFX. L’apertura massima cambia con la focale: non viene usato un singolo valore per classificarne la luminosità.'
  }
]
